export default "__VITE_ASSET__BYb0hE3B__"